'use strict';

import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SliderComponent } from './component';
import { FormsModule } from '@angular/forms';

@NgModule({
  imports     : [
    BrowserModule,
    FormsModule
  ],
  declarations: [SliderComponent],
  exports     : [SliderComponent]
})
export class LKSlider {

}
